import {
  CalendarOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import { meetingStatus } from 'commons/libs/meeting_utils';
import {
  Meeting,
  MEETING_STATUSES,
  MEETING_TYPES,
  MeetingStatus,
} from 'commons/types/meetingsTypes';

interface MeetingItemProps {
  meeting: Meeting;
}

export default function MeetingItem({ meeting }: MeetingItemProps) {
  return (
    <div className='flex flex-row  bg-primary-light rounded-2xl px-2 py-4 mb-1 mx-2'>
      <div className='flex flex-row w-full'>
        <div className='flex flex-col justify-center h-full relative'>
          <CalendarOutlined className='text-3xl mr-3' />
          <Status status={meeting.status} />
        </div>
        <div className='flex flex-col justify-start text-left mt-2 ml-2'>
          <p className='font-semibold text-sm m-0'>{getEntity(meeting)}</p>

          <p className='font-light text-sm m-0 capitalize'>
            {dayjs(meeting.start_date, 'YYYY-MM-DDTHH:mm:ss.000ZZ').format(
              'dddd LL',
            )}
          </p>
        </div>
      </div>
      <div className='self-center w-[50%]'>{meetingStatus(meeting)}</div>
    </div>
  );
}

function getEntity(meeting: Meeting) {
  const name =
    meeting.metadata.employee === undefined || meeting.metadata.employee === ''
      ? undefined
      : meeting.metadata.employee;

  switch (meeting.type) {
    case MEETING_TYPES.RDV_1:
      return `${name || 'Téléconseiller'}`;
    case MEETING_TYPES.RDV_2:
      return `${name || 'Infirmier'}`;
    default:
      return name ? `Dr ${name}` : 'Docteur';
  }
}

function Status({ status }: { status: MeetingStatus }) {
  switch (status) {
    case MEETING_STATUSES.ACCEPTED:
      return (
        <CheckCircleOutlined
          className='absolute right-2 bottom-1 bg-white'
          style={{ color: 'green' }}
        />
      );
    case MEETING_STATUSES.REFUNDED:
      return (
        <CloseCircleOutlined
          className='absolute right-2 bottom-1 bg-white'
          style={{ color: 'red' }}
        />
      );
    default:
      return null;
  }
}
